import React from "react";
import Misc from "./Misc.svg";

import { SelectorLabel, ShuffleBtn } from "../../styles";

const Shuffle = ({ randomise, setExpanded, expanded, edit }) => {
  const handleClick = () => {
    randomise();
    !expanded  && setExpanded ? setExpanded(true) : null;
  };
  return (
    <ShuffleBtn id="shuffle-products" onClick={handleClick} $edit={edit}>
      Auto-Fill
      {Misc.SelectionShuffleIcon}
    </ShuffleBtn>
   
  );
};

export default Shuffle;
